// extracted by mini-css-extract-plugin
export default {"container":"VL-z","topReviewHeading":"WL-z","criticalReview":"XL-z","favorableReview":"YL-z","vsSeparator":"ZL-z"};